// Web Amplify v6 configuration — env-var driven at Vite build time
// VITE_ vars are injected by GitHub Actions deploy.yml secrets; fallbacks are the prod values

export const cognitoConfig = {
  userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID ?? 'us-east-1_b4j03EwaB',
  userPoolClientId: import.meta.env.VITE_COGNITO_USER_POOL_CLIENT_ID ?? '6biu1asvbfuhp4i4cq6rruist4',
  identityPoolId: import.meta.env.VITE_COGNITO_IDENTITY_POOL_ID ?? '',
  oauthDomain: 'mylife-auth.auth.us-east-1.amazoncognito.com',
  redirectSignIn: 'https://app.mylifehistory.xyz/',
  redirectSignOut: 'https://app.mylifehistory.xyz/',
} as const;

export const amplifyConfig = {
  Auth: {
    Cognito: {
      userPoolId: cognitoConfig.userPoolId,
      userPoolClientId: cognitoConfig.userPoolClientId,
      identityPoolId: cognitoConfig.identityPoolId,
      signUpVerificationMethod: 'code' as const,
      loginWith: {
        email: true,
        username: false,
        oauth: {
          domain: cognitoConfig.oauthDomain,
          scopes: ['email', 'openid', 'profile'] as string[],
          redirectSignIn: [cognitoConfig.redirectSignIn, 'http://localhost:5173/'] as string[],
          redirectSignOut: [cognitoConfig.redirectSignOut, 'http://localhost:5173/'] as string[],
          responseType: 'code' as const,
        },
      },
    },
  },
};

export const apiConfig = {
  restApiUrl: import.meta.env.VITE_REST_API_URL ?? 'https://64dk9x9xhd.execute-api.us-east-1.amazonaws.com/prod',
  wsApiUrl: import.meta.env.VITE_WSS_URL ?? 'wss://sthcpke1xd.execute-api.us-east-1.amazonaws.com/prod',
  jobStatusUrl: import.meta.env.VITE_JOB_STATUS_URL ?? '',
  adminSub: import.meta.env.VITE_ADMIN_SUB ?? '',
} as const;
